import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface AddClubPlayerDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  playerName: string;
  onPlayerNameChange: (name: string) => void;
  whsId: string;
  onWhsIdChange: (id: string) => void;
  onAddPlayer: () => void;
  errorMessage?: string | null;
  clubName: string;
}

const AddClubPlayerDialog: React.FC<AddClubPlayerDialogProps> = ({
  isOpen,
  onOpenChange,
  playerName,
  onPlayerNameChange,
  whsId,
  onWhsIdChange,
  onAddPlayer,
  errorMessage,
  clubName,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add New Club Player</DialogTitle>
          <p className="text-sm text-muted-foreground">
            This player will be associated to <strong>{clubName}</strong> but not linked directly to a specific team
          </p>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="name">Player Name</Label>
            <Input
              id="name"
              value={playerName}
              onChange={(e) => onPlayerNameChange(e.target.value)}
              placeholder="Enter full name"
            />
          </div>
          <div>
            <Label htmlFor="whsId">WHS ID</Label>
            <Input
              id="whsId"
              value={whsId}
              onChange={(e) => onWhsIdChange(e.target.value)}
              placeholder="Enter 10-digit WHS ID"
            />
            <p className="text-sm text-muted-foreground italic pt-1">
              {whsId.length}/10 digits
            </p>
          </div>
          <p className="text-xs text-muted-foreground italic pt-1">
            Once added, a player's name or WHS ID cannot be edited.
          </p>
          {errorMessage && (
            <p className="text-sm text-red-500">{errorMessage}</p>
          )}
          <Button className="w-full bg-[#30702F] hover:bg-[#256021]" onClick={onAddPlayer}>
            Add Player
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddClubPlayerDialog;